module.exports = __webpack_public_path__ + "media/124.cc5966f4.mp3";